// extracted by mini-css-extract-plugin
module.exports = {"container":"SummaryCard_container__1kZbR","large":"SummaryCard_large__3TJs9","value":"SummaryCard_value__OA6qF","title":"SummaryCard_title__174A4"};